import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_inventory_counts_grid_ComponentContextService } from './FootprintManager.inventory_counts_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { InventoryCounts_inventory_count_statuses_dd_multiComponent } from './InventoryCounts.inventory_count_statuses_dd_multi.component'


interface IFootprintManager_inventory_counts_gridComponentEntity {
  Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Description?: string, LookupCode?: string, Status?: { Id?: number, Name?: string }, Warehouse?: { Name?: string }, Discrepancies?: { Id?: number }[]}

interface IFootprintManager_inventory_counts_gridComponentInParams {
  warehouseIds?: number[], statusIds?: number[]}


class FootprintManager_inventory_counts_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_inventory_counts_gridComponent;
  entity: IFootprintManager_inventory_counts_gridComponentEntity;

  vars: { canRelease?: boolean, canHold?: boolean, canComplete?: boolean, canDuplicate?: boolean, canCancel?: boolean, canDelete?: boolean } = { };


 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    status_name: null,
    lookupcode: null,
    discrepancies: null,
    description: null,
    warehouse_name: null,
    created_date: null,
    created_by: null,
  }



  constructor(
    grid: FootprintManager_inventory_counts_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_inventory_counts_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.status_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.status_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.lookupcode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.lookupcode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.discrepancies = new GridCellModel(
      new CellStyles(['left'], null),
      this.grid.headers.discrepancies,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.description = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.description,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.warehouse_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_by = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_by,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_inventory_counts_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_inventory_counts_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      warehouseIds:  $grid.inParams.warehouseIds ,
      statusIds:  $grid.filters.status.control.value ,
      fullTextSearch:  $grid.fullTextSearch ,
      onlyCountsWithDiscrepancies:  $grid.filters.only_discrepancies.control.value ,
    };
    const data = await this.$datasources.InventoryCounts.ds_inventory_counts_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_inventory_counts_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.status_name.displayControl as TextModel).text = $row.entity.Status.Name;
    (this.cells.lookupcode.displayControl as TextModel).text = $row.entity.LookupCode;
    (this.cells.description.displayControl as TextModel).text = $row.entity.Description;
    (this.cells.warehouse_name.displayControl as TextModel).text = $row.entity.Warehouse.Name;
    (this.cells.created_date.displayControl as TextModel).text = $row.entity.CreatedSysDateTime?.toString();
    (this.cells.created_by.displayControl as TextModel).text = $row.entity.CreatedSysUser;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'lookupcode' : {
        this.on_lookupcode_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_inventory_counts_gridComponentRowModel,
  $grid: FootprintManager_inventory_counts_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_counts_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // Apply date formatting
  // $row.cells.batch_release_date.displayControl.text = $utils.isDefined($row.entity.InventoryCountTaskProperties[0]?.BatchCreationTime) ? 
  //     $utils.date.format($row.cells.batch_release_date.displayControl.text, $settings.InventoryCounts.DateFormat + ' HH:mm') : '';
  $row.cells.created_date.displayControl.text = $utils.date.format($row.cells.created_date.displayControl.text, $settings.InventoryCounts.DateFormat + ' HH:mm');
  $row.cells.discrepancies.styles.setAttentionClass();
  // Format username
  $row.cells.created_date.displayControl.text = $row.cells.created_date.displayControl.text.substring(
      $row.cells.created_date.displayControl.text.indexOf(`\\`) + 1,
      $row.cells.created_date.displayControl.text.indexOf('@') >= 0 ? $row.cells.created_date.displayControl.text.indexOf('@') : $row.cells.created_date.displayControl.text.length
  );
  
  // Get Task Data
  let totalTasks = 0;
  let remainingTasks = 0;
  
  // Calculate Tasks
  // if ($utils.isDefined($row.entity?.InventoryCountTaskProperties)) {
  //     for (let property of $row.entity?.InventoryCountTaskProperties) {
  //         let parentTask = $row.entity?.InventoryCountTaskProperties.find(p => p.Task.Id = property.Task.ChainHead);
  //         if (!$utils.isDefined(parentTask)) {
  //             let isResolved = property.Task.StatusId === 2 || property.Task.StatusId === 3;
  //             let taskId = property.TaskId;
  
  //             if (taskId === 0) {
  //                 throw new Error('TaskId equals 0');
  //             }
  
  //             while (isResolved && $utils.isDefined(taskId)) {
  //                 let childTask = $row.entity?.InventoryCountTaskProperties.find(p => p.Task.ChainHead === taskId);
  
  //                 if ($utils.isDefined(childTask)) {
  //                     isResolved = childTask.Task.StatusId === 2 || childTask.Task.StatusId === 3;
  //                     taskId = childTask.TaskId;
  //                 }
  //                 else {
  //                     taskId = null;
  //                 }
  //             }
  
  //             totalTasks += 1;
  //             if (!isResolved) {
  //                 remainingTasks += 1;
  //             }
  //         }
  //     }
  // }
  
   $row.cells.status_name.displayControl.text = (await $flows.InventoryCounts.get_inventory_count_status_flow({
       inventoryCountIds: [$row.entity.Id],
      //  optimalInputs: [{
      //      inventoryCountId: $row.entity.Id,
      //      statusId: $row.entity.Status.Id,
      //      statusName: $row.entity.Status.Name,
      //      tasks: null
      //     //     $row.entity.InventoryCountTaskProperties.map(p => ({
      //     //      operationCodeId: p.Task.OperationCodeId,
      //     //      statusId: p.Task.StatusId
      //     //  }))
      //  }]
   }))?.inventoryCounts[0]?.descriptiveStatusName ?? $row.cells.status_name.displayControl.text;
  
  // $row.cells.total_tasks.displayControl.text = totalTasks.toString();
  // $row.cells.remaining_tasks.displayControl.text = remainingTasks.toString();
  }
  on_lookupcode_clicked(event = null) {
    return this.on_lookupcode_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lookupcode_clickedInternal(
    $row: FootprintManager_inventory_counts_gridComponentRowModel,
  $grid: FootprintManager_inventory_counts_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_counts_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $shell.FootprintManager.openinventory_count_editor({inventoryCountId: $row.entity.Id });
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => InventoryCounts_inventory_count_statuses_dd_multiComponent),
  ],
  selector: 'FootprintManager-inventory_counts_grid',
  templateUrl: './FootprintManager.inventory_counts_grid.component.html'
})
export class FootprintManager_inventory_counts_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_inventory_counts_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_inventory_counts_gridComponentInParams = { warehouseIds: [], statusIds: [] };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     status_name: new GridHeaderModel(new HeaderStyles(null, null), 'status_name', 'Status', false, false, null, false),       lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'lookupcode', 'Count', false, false, null, false),       discrepancies: new GridHeaderModel(new HeaderStyles(['left'], null), 'discrepancies', 'Discrepancies', false, false, null, false),       description: new GridHeaderModel(new HeaderStyles(null, null), 'description', 'Description', false, false, null, false),       warehouse_name: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse_name', 'Warehouse', false, false, null, false),       created_date: new GridHeaderModel(new HeaderStyles(null, null), 'created_date', 'Created on', false, false, null, false),       created_by: new GridHeaderModel(new HeaderStyles(null, null), 'created_by', 'Created by', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_inventory_counts_gridComponentRowModel[] = [];

  @Input('warehouseIds') set $inParams_warehouseIds(value: any) {
    this.inParams['warehouseIds'] = value;
  }
  get $inParams_warehouseIds(): any {
    return this.inParams['warehouseIds'] ;
  }
  @Input('statusIds') set $inParams_statusIds(value: any) {
    this.inParams['statusIds'] = value;
  }
  get $inParams_statusIds(): any {
    return this.inParams['statusIds'] ;
  }

  topToolbar = {
      release_count: new ToolModel(new ButtonModel('release_count', new ButtonStyles(null, null), false, false, false, 'Start', 'icon-ic_fluent_play_circle_20_regular', null)
    , false),
      hold_count: new ToolModel(new ButtonModel('hold_count', new ButtonStyles(null, null), false, false, false, 'Pause', 'icon-ic_fluent_pause_circle_20_regular', null)
    , false),
      complete_count: new ToolModel(new ButtonModel('complete_count', new ButtonStyles(null, null), false, false, false, 'Complete', 'icon-ic_fluent_checkmark_circle_20_regular', null)
    , false),
      separator2: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      duplicate_count: new ToolModel(new ButtonModel('duplicate_count', new ButtonStyles(null, null), false, false, false, 'Duplicate', 'icon-ic_fluent_copy_20_regular', null)
    , false),
      separator1: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      cancel_count: new ToolModel(new ButtonModel('cancel_count', new ButtonStyles(null, null), false, false, false, 'Cancel', 'icon-ic_fluent_dismiss_circle_20_regular', null)
    , false),
      delete_count: new ToolModel(new ButtonModel('delete_count', new ButtonStyles(['destructive'], null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false)
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    only_discrepancies: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    status: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    only_discrepancies: new FieldModel(new CheckBoxModel(this.formGroup.controls['only_discrepancies'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Counts with discrepancies only', false, false),
    status: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['status'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Status', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_inventory_counts_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Inventory counts';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 10;

    (this.filters.only_discrepancies.control as CheckBoxModel).reset(false);
    (this.filters.status.control as SelectBoxModel).reset([1,2]);

    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      warehouseIds:  $grid.inParams.warehouseIds ,
      statusIds:  $grid.filters.status.control.value ,
      fullTextSearch:  $grid.fullTextSearch ,
      onlyCountsWithDiscrepancies:  $grid.filters.only_discrepancies.control.value ,
    };
    try {
      const data = await this.$datasources.InventoryCounts.ds_inventory_counts_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_inventory_counts_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_inventory_counts_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_inventory_counts_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_release_count_clicked(event = null) {
    return this.on_release_count_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_release_count_clickedInternal(
    $grid: FootprintManager_inventory_counts_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_counts_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  let message: string;
  let title: string;
  
  if ($grid.selectedRows.length === 0) {
      return;
  }
  else if ($grid.selectedRows.length === 1) {
      title = `Start count ${$grid.selectedRows[0].entity.LookupCode}?`
  
      message = 'Once started you will not be able to make any further changes.';
  }
  else {
      title = `Start counts ${$grid.selectedRows.map(r => r.entity.LookupCode).join(', ')}?`;
  
      message = 'Once started you will not be able to make any further changes.';
  }
  
  let isConfirmed = (await $shell.InventoryCounts.openConfirmationDialog(title, message, 'Start count' + ($grid.selectedRows.length > 1 ? 's' : ''), 'Cancel'));
  
  if (isConfirmed) {
      // Proceed with processing rows
      let successfulCounts: string[] = [];
      let failedCounts: { lookupCode: string, errors: string[] }[] = [];
  
      for (let row of $grid.selectedRows) {
          // Release InventoryCount(s)
          let result = (await $flows.InventoryCounts.set_inventory_count_released_flow({ inventoryCountId: row.entity.Id }));
  
          if ($utils.isDefined(result.errors)) {
              failedCounts.push({ lookupCode: row.entity.LookupCode, errors: result.errors });
          }
          else {
              successfulCounts.push(row.entity.LookupCode);
          }
      }
  
      // Format message
      message = '';
      if ($utils.isDefined(successfulCounts)) {
          message += `Successfully released ${successfulCounts.length === 1 ? 'count' : 'counts'} ${successfulCounts.join(', ')}. `;
      }
      if ($utils.isDefined(failedCounts)) {
          message += `Failed to release ${failedCounts.length === 1 ? 'count' : 'counts'} ${failedCounts.map(c => `${c.lookupCode} (${c.errors.join(' & ')})`).join(', ')}. `;
      }
  
      await $shell.InventoryCounts.openInfoDialog(title, message);
  
      await $grid.refresh();
  }
  }
  on_complete_count_clicked(event = null) {
    return this.on_complete_count_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_complete_count_clickedInternal(
    $grid: FootprintManager_inventory_counts_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_counts_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  let message: string;
  let title: string;
  
  if ($grid.selectedRows.length === 0) {
      return;
  }
  else if ($grid.selectedRows.length === 1) {
      title = `Complete count ${$grid.selectedRows[0].entity.LookupCode}?`;
  
      message = 'Once completed you will not be able to make any further changes.';
  }
  else {
      title = `Complete counts ${$grid.selectedRows.map(r => r.entity.LookupCode).join(', ')}?`;
  
      message = 'Once completed you will not be able to make any further changes.';
  }
  
  let isConfirmed = (await $shell.InventoryCounts.openConfirmationDialog(title, message, 'Complete count' + ($grid.selectedRows.length > 1 ? 's' : ''), 'Cancel'));
  
  if (isConfirmed) {
      // Proceed with processing rows
      let successfulCounts: string[] = [];
      let failedCounts: { lookupCode: string, errors: string[] }[] = [];
  
      for (let row of $grid.selectedRows) {
          // Complete InventoryCount(s)
          let result = (await $flows.InventoryCounts.set_inventory_count_completed_flow({ inventoryCountId: row.entity.Id, isCancelOutstanding: true }));
  
          if ($utils.isDefined(result.errors)) {
              failedCounts.push({ lookupCode: row.entity.LookupCode, errors: result.errors });
          }
          else {
              successfulCounts.push(row.entity.LookupCode);
          }
      }
  
      // Format message
      message = '';
      if ($utils.isDefined(successfulCounts)) {
          message += `Successfully completed ${successfulCounts.length === 1 ? 'count' : 'counts'} ${successfulCounts.join(', ')}. `;
      }
      if ($utils.isDefined(failedCounts)) {
          message += `Failed to complete ${failedCounts.length === 1 ? 'count' : 'counts'} ${failedCounts.map(c => `${c.lookupCode} (${c.errors.join(' & ')})`).join(', ')}. `;
      }
  
      await $shell.InventoryCounts.openInfoDialog(title, message);
  
      await $grid.refresh();
  }
  }
  on_hold_count_clicked(event = null) {
    return this.on_hold_count_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_hold_count_clickedInternal(
    $grid: FootprintManager_inventory_counts_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_counts_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  let message: string;
  let title: string;
  
  if ($grid.selectedRows.length === 0) {
      return;
  }
  else if ($grid.selectedRows.length === 1) {
      title = `Pause count ${$grid.selectedRows[0].entity.LookupCode}?`;
  
      message = null;
  }
  else {
      title = `Pause counts ${$grid.selectedRows.map(r => r.entity.LookupCode).join(', ')}?`;
  
      message = null;
  }
  
  let isConfirmed = (await $shell.InventoryCounts.openConfirmationDialog(title, message, 'Pause count' + ($grid.selectedRows.length > 1 ? 's' : ''), 'Cancel'));
  
  if (isConfirmed) {
      // Proceed with processing rows
      let successfulCounts: string[] = [];
      let failedCounts: { lookupCode: string, errors: string[] }[] = [];
  
      for (let row of $grid.selectedRows) {
          // Place InventoryCount(s) on hold
          let result = (await $flows.InventoryCounts.set_inventory_count_on_hold_flow({ inventoryCountId: row.entity.Id }));
  
          if ($utils.isDefined(result.errors)) {
              failedCounts.push({ lookupCode: row.entity.LookupCode, errors: result.errors });
          }
          else {
              successfulCounts.push(row.entity.LookupCode);
          }
      }
  
      // Format message
      message = '';
      if ($utils.isDefined(successfulCounts)) {
          message += `Successfully placed ${successfulCounts.length === 1 ? 'count' : 'counts'} ${successfulCounts.join(', ')} on pause. `;
      }
      if ($utils.isDefined(failedCounts)) {
          message += `Failed to place ${failedCounts.length === 1 ? 'count' : 'counts'} ${failedCounts.map(c => `${c.lookupCode} (${c.errors.join(' & ')})`).join(', ')} on pause. `;
      }
  
      await $shell.InventoryCounts.openInfoDialog(title, message);
  
      await $grid.refresh();
  }
  }
  on_cancel_count_clicked(event = null) {
    return this.on_cancel_count_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_cancel_count_clickedInternal(
    $grid: FootprintManager_inventory_counts_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_counts_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  let message: string;
  let title: string;
  
  if ($grid.selectedRows.length === 0) {
      return;
  }
  else if ($grid.selectedRows.length === 1) {
      title = `Cancel count ${$grid.selectedRows[0].entity.LookupCode}?`;
  
      message = null;
  }
  else {
      title = `Cancel counts ${$grid.selectedRows.map(r => r.entity.LookupCode).join(', ')}?`;
      
      message = null;
  }
  
  let isConfirmed = (await $shell.InventoryCounts.openConfirmationDialog(title, message, 'Cancel count' + ($grid.selectedRows.length > 1 ? 's' : ''), 'Not now'));
  
  if (isConfirmed) {
      // Proceed with processing rows
      let successfulCounts: string[] = [];
      let failedCounts: { LookupCode: string, errors: string[] }[] = [];
  
      for (let row of $grid.selectedRows) {
          // Cancel InventoryCount(s)
          let result = (await $flows.InventoryCounts.set_inventory_count_cancelled_flow({ inventoryCountId: row.entity.Id }));
  
          if ($utils.isDefined(result.errors)) {
              failedCounts.push({ LookupCode: row.entity.LookupCode, errors: result.errors });
          }
          else {
              successfulCounts.push(row.entity.LookupCode);
          }
      }
  
      // Format message
      message = '';
      if ($utils.isDefined(successfulCounts)) {
          message += `Successfully cancelled ${successfulCounts.length === 1 ? 'count' : 'counts'} ${successfulCounts.join(', ')}. `;
      }
      if ($utils.isDefined(failedCounts)) {
          message += `Failed to cancel ${failedCounts.length === 1 ? 'count' : 'counts'} ${failedCounts.map(c => `${c.LookupCode} (${c.errors.join(' & ')})`).join(', ')}. `;
      }
  
      await $shell.InventoryCounts.openInfoDialog(title, message);
  
      await $grid.refresh();
  }
  }
  on_delete_count_clicked(event = null) {
    return this.on_delete_count_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_count_clickedInternal(
    $grid: FootprintManager_inventory_counts_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_counts_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  let message: string;
  let title: string;
  
  if ($grid.selectedRows.length === 0) {
      return;
  }
  else if ($grid.selectedRows.length === 1) {
      title = `Delete count ${$grid.selectedRows[0].entity.LookupCode}?`;
  
      message = null;
  }
  else {
      title = `Delete counts ${$grid.selectedRows.map(r => r.entity.LookupCode).join(', ')}?`;
  
      message = null;
  }
  
  let isConfirmed = (await $shell.InventoryCounts.openConfirmationDialog(title, message, 'Delete count' + ($grid.selectedRows.length > 1 ? 's' : ''), 'Not now'));
  
  if (isConfirmed) {
      // Proceed with processing rows
      let successfulCounts: string[] = [];
      let failedCounts: { lookupCode: string, errors: string[] }[] = [];
  
      for (let row of $grid.selectedRows) {
          // Delete InventoryCount(s)
          let result = (await $flows.InventoryCounts.delete_inventory_count_flow({ inventoryCountId: row.entity.Id }));
  
          if ($utils.isDefined(result.errors)) {
              failedCounts.push({ lookupCode: row.entity.LookupCode, errors: result.errors });
          }
          else {
              successfulCounts.push(row.entity.LookupCode);
          }
      }
  
      // Format message
      message = '';
      if ($utils.isDefined(successfulCounts)) {
          message += `Successfully deleted ${successfulCounts.length === 1 ? 'count' : 'counts'} ${successfulCounts.join(', ')}. `;
      }
      if ($utils.isDefined(failedCounts)) {
          message += `Failed to delete ${failedCounts.length === 1 ? 'count' : 'counts'} ${failedCounts.map(c => `${c.lookupCode} (${c.errors.join(' & ')})`).join(', ')}. `;
      }
  
      await $shell.InventoryCounts.openInfoDialog(title, message);
  
      await $grid.refresh();
  }
  }
  on_duplicate_count_clicked(event = null) {
    return this.on_duplicate_count_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_duplicate_count_clickedInternal(
    $grid: FootprintManager_inventory_counts_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_counts_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  let message: string;
  let title: string;
  
  if ($grid.selectedRows.length === 0) {
      return;
  }
  else if ($grid.selectedRows.length === 1) {
      title = `Duplicate count ${$grid.selectedRows[0].entity.LookupCode}?`;
  
      message = null;
      
      
  }
  else {
      title = `Duplicate counts ${$grid.selectedRows.map(r => r.entity.LookupCode).join(', ')}?`;
  
      message = null; 
  }
  
  let isConfirmed = (await $shell.InventoryCounts.openConfirmationDialog(title, message, 'Duplicate count' + ($grid.selectedRows.length > 1 ? 's' : ''), 'Cancel'));
  
  if (isConfirmed) {
      // Proceed with processing rows
      let successfulCounts: string[] = [];
      let failedCounts: { lookupCode: string, errors: string[] }[] = [];
  
      for (let row of $grid.selectedRows) {
          // Duplicate InventoryCount(s)
          let result = (await $flows.InventoryCounts.create_duplicate_inventory_count_flow({ inventoryCountId: row.entity.Id }));
  
          if ($utils.isDefined(result.errors)) {
              failedCounts.push({ lookupCode: row.entity.LookupCode, errors: result.errors });
          }
          else {
              successfulCounts.push(row.entity.LookupCode);
          }
      }
  
      // Format message
      message = '';
      if ($utils.isDefined(successfulCounts)) {
          message += `Successfully duplicated ${successfulCounts.length === 1 ? 'count' : 'counts'} ${successfulCounts.join(', ')}. `;
      }
      if ($utils.isDefined(failedCounts)) {
          message += `Failed to duplicate ${failedCounts.length === 1 ? 'count' : 'counts'} ${failedCounts.map(c => `${c.lookupCode} (${c.errors.join(' & ')})`).join(', ')}. `;
      }
  
      await $shell.InventoryCounts.openInfoDialog(title, message);
  
      await $grid.refresh();
  }
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootprintManager_inventory_counts_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_counts_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($grid.selectedRows.length === 0) {
      $grid.topToolbar.release_count.control.readOnly = true;
      $grid.topToolbar.hold_count.control.readOnly = true;
      $grid.topToolbar.complete_count.control.readOnly = true;
      $grid.topToolbar.cancel_count.control.readOnly = true;
      $grid.topToolbar.delete_count.control.readOnly = true;
      $grid.topToolbar.duplicate_count.control.readOnly = true;
      return;
  }
  
  // Check if all can Release
  $grid.topToolbar.release_count.control.readOnly = $grid.selectedRows.some(row => !row.vars.canRelease);
  $grid.topToolbar.hold_count.control.readOnly = $grid.selectedRows.some(row => !row.vars.canHold);
  $grid.topToolbar.duplicate_count.control.readOnly = $grid.selectedRows.some(row => !row.vars.canDuplicate);
  $grid.topToolbar.complete_count.control.readOnly = $grid.selectedRows.some(row => !row.vars.canComplete);
  $grid.topToolbar.cancel_count.control.readOnly = $grid.selectedRows.some(row => !row.vars.canCancel);
  $grid.topToolbar.delete_count.control.readOnly = $grid.selectedRows.some(row => !row.vars.canDelete);
  
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_inventory_counts_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_counts_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // Set toolbar items
  $grid.topToolbar.release_count.control.readOnly = true;
  $grid.topToolbar.hold_count.control.readOnly = true;
  $grid.topToolbar.complete_count.control.readOnly = true;
  $grid.topToolbar.cancel_count.control.readOnly = true;
  $grid.topToolbar.delete_count.control.readOnly = true;
  $grid.topToolbar.duplicate_count.control.readOnly = true;
  
  
  }
  on_grid_data_loaded(event = null) {
    return this.on_grid_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadedInternal(
    $grid: FootprintManager_inventory_counts_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_counts_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  for (let row of $grid.rows) {
      row.cells.discrepancies.displayControl.text = $utils.isDefined(row.entity.Discrepancies) ? `⚠ ${row.entity.Discrepancies.length} Discrepanc${row.entity.Discrepancies.length === 1 ? 'y' : 'ies'}` : '';
  }
  
  let statusDetails = (await $flows.InventoryCounts.get_inventory_count_status_flow({
      inventoryCountIds: $grid.rows.map(r => r.entity.Id)
  })).inventoryCounts;
  
  for (let row of $grid.rows) {
      const state = statusDetails.find(s => s.id === row.entity.Id);
  
      row.vars.canCancel = !$utils.isDefined(state.actionValidations.failCancelReasons);
      row.vars.canComplete = !$utils.isDefined(state.actionValidations.failCompleteReasons);
      row.vars.canDelete = !$utils.isDefined(state.actionValidations.failDeleteReasons);
      row.vars.canDuplicate = !$utils.isDefined(state.actionValidations.failDuplicateReasons);
      row.vars.canHold = !$utils.isDefined(state.actionValidations.failHoldReasons);
      row.vars.canRelease = !$utils.isDefined(state.actionValidations.failReleaseReasons);
  }
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
